import Point from 'ol/geom/Point';
import { useCallback, useState } from 'react';
import { useOpenLayers } from '../react-ol';
import useApplicationState from './useApplicationState';
import useDefaultsCache from './useDefaultsCache';

var useResetToDefaultPosition = () => {
  var {
    overrides
  } = useApplicationState();
  var {
    cachedDefaults
  } = useDefaultsCache();
  var {
    map
  } = useOpenLayers();
  var [isAnimating, setIsAnimating] = useState(false);
  return useCallback(options => {
    if (map && cachedDefaults && !isAnimating) {
      var defaultZoom = (overrides === null || overrides === void 0 ? void 0 : overrides.defaultZoom) || cachedDefaults.defaultScale.openLayersLevel;
      var defaultCenter = (overrides === null || overrides === void 0 ? void 0 : overrides.defaultCenter) || [cachedDefaults.defaultPositionX, cachedDefaults.defaultPositionY]; // Convert coordinates to point so it can be passed to `view.fit()`

      var defaultCenterPoint = new Point(defaultCenter).getExtent();
      map.getView().fit(defaultCenterPoint, {
        duration: (options === null || options === void 0 ? void 0 : options.duration) || 600,
        padding: options === null || options === void 0 ? void 0 : options.padding,
        maxZoom: defaultZoom
      });
      setIsAnimating(true);
      setTimeout(() => {
        setIsAnimating(false);
      }, (options === null || options === void 0 ? void 0 : options.duration) || 600);
    }
  }, [map, overrides, cachedDefaults, isAnimating]);
};

export default useResetToDefaultPosition;